
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"37","height":"11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M24.38 9.73a.38.38 0 010 .75h-24a.38.38 0 010-.75h24zm11.48-3.24a.38.38 0 010 .75H.38a.38.38 0 010-.75h35.48zm0-3.24a.38.38 0 010 .75H.38a.38.38 0 010-.75h35.48zm0-3.25a.38.38 0 010 .75H.38a.38.38 0 010-.75h35.48z"}})])
          )
        }
      }
    